gcsi_user_uuid